// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  QUESTIONDB: '/questiondb',
  INQUIRY: '/inquiry',
  USERDB: '/userdb',
  Q_GEN: '/qgen',
  WORKBOOK: '/workbook',
};

// ----------------------------------------------------------------------

export const paths = {
  stuki: 'https://www.stuki.co.kr',
  // AUTH
  auth: {
    supabase: {
      login: `${ROOTS.AUTH}/supabase/login`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      register: `${ROOTS.AUTH}/supabase/register`,
      newPassword: `${ROOTS.AUTH}/supabase/new-password`,
      forgotPassword: `${ROOTS.AUTH}/supabase/forgot-password`,
      pending: `${ROOTS.AUTH}/supabase/pending`,
      findEmail: `${ROOTS.AUTH}/supabase/find-email`,
    },
  },
  dashboard: {
    root: ROOTS.DASHBOARD,
  },
  questiondb: {
    list: `${ROOTS.QUESTIONDB}/list`,
    new: `${ROOTS.QUESTIONDB}/new`,
    edit: (id) => `${ROOTS.QUESTIONDB}/${id}/edit`,
    report: `${ROOTS.QUESTIONDB}/report`,
  },
  inquiry: {
    list: `${ROOTS.INQUIRY}/list`,
  },
  qgen: {
    new: `${ROOTS.Q_GEN}/new`,
    list: `${ROOTS.Q_GEN}/list`,
  },
  userdb: {
    list: `${ROOTS.USERDB}/list`,
    edit: `${ROOTS.USERDB}/userdb/edit`,
  },
  workbook: {
    new: `${ROOTS.WORKBOOK}/new`,
    list: `${ROOTS.WORKBOOK}/list`,
  },
};
